import { render, staticRenderFns } from "./assignment_questions_v2.vue?vue&type=template&id=b5912b04&scoped=true&"
import script from "./assignment_questions_v2.vue?vue&type=script&lang=js&"
export * from "./assignment_questions_v2.vue?vue&type=script&lang=js&"
import style0 from "./assignment_questions_v2.vue?vue&type=style&index=0&id=b5912b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5912b04",
  null
  
)

export default component.exports